import { joinPath } from '../../core/utils';
import type { ContainerStorageBlockOptions, ContainerStoragePaths } from './types';

export function resolveContainerStoragePaths(prefix: string, options?: ContainerStorageBlockOptions): ContainerStoragePaths {
  const segment = options?.listSegment ?? 'volumes';
  return {
    volumes: joinPath(prefix, segment),
  };
}
